export default "__VITE_ASSET__rLVJSxfH__"